import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';




class LineChart extends Component {
  constructor(props) {
    super(props);
    

    this.state = {
      labels: [],
      datasets: [ ]
    }
  }
    lineChartFunctionalData(){
      let data = this.props.data
    let newData = []
    data.map((value, index) =>{
      value.map((val,ind)=>{
      val=val.replace('%','')
      newData.push(parseInt(val))
      
    this.setState({
      labels: this.props.labels,
      datasets: [
        {
          label: 'Closure Percentage',
          fill: false,
          lineTension: 0.5,
          backgroundColor: '#FF6384',
          borderColor: '#0082C3',
          borderWidth: 2,
          data: newData
        }
      ]
    })
      
      
      })

    })
  }
componentDidMount(){
  this.lineChartFunctionalData()
}

componentDidUpdate(prevProps){
  if ((prevProps.data !== this.props.data) && (prevProps.labels !== this.props.labels)) {

    this.lineChartFunctionalData()
  }
}
  

  render() {
    return (
      <>
        <Line
          data={this.state}
          width={400}
          height={200}
          options={{
            tooltips: {
              callbacks: {
                label: function(tooltipItem, data) {
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                  var total = meta.total;
                  var currentValue = dataset.data[tooltipItem.index];
                  var percentage = parseFloat((currentValue/total*100).toFixed(1));
                  return currentValue + '%';
                },
                title: function(tooltipItem, data) {
                  return data.labels[tooltipItem[0].index];
                }
              }
            },
            title: {
              display: true,
              text: 'Incident report vs Closure Status',
              fontSize: 20
            },
            legend: {
              display: true,
              position: 'top'
            }
          }}
        />
      </>
    );
  }
}

export default LineChart;